import React from 'react';
import { Form, FormikProps } from 'formik';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { useRootStore } from '../../../../../providers/root-store-provider';
import { Alert } from '../../../alert/alert';
import { FairPriceFormValues } from '../../form-values/fair-price-form-values-interface';
import { FairPriceTabFcfParameters } from './parameters/fair-price-tab-fcf-parameters';
import { FairPriceTabFcfResults } from './results/fair-price-tab-fcf-results';
import { FairPriceTabFcfStats } from './stats/fair-price-tab-fcf-stats';

interface FairPriceTabFcfProps {
    formikProps: FormikProps<FairPriceFormValues>;
}

export const FairPriceTabFcf: React.FC<FairPriceTabFcfProps> = observer(({ formikProps }) => {
    const { t } = useTranslation();
    const {
        symbolsStore: { symbolFairPriceStore, symbolDetailStore },
    } = useRootStore();
    const { fcfPerShare, fcfYield, currentPrice, fairPriceFCF, upsideDownsideFCF } = symbolFairPriceStore;
    const currency = symbolDetailStore?.general?.symbol?.currency || 'USD';
    const showResult = fairPriceFCF > 0 && currentPrice > 0;

    if (!currentPrice || fcfPerShare === null) {
        return (
            <div>
                <Alert type={'warning'} icon>
                    {t('layout.dialogs.fairPrice.fcf.noData')}
                </Alert>
            </div>
        );
    }

    return (
        <Form id={'fair-price-form'}>
            <FairPriceTabFcfStats currency={currency} fcfPerShare={fcfPerShare} fcfYield={fcfYield} />
            <FairPriceTabFcfParameters formikProps={formikProps} showResult={showResult} />
            <FairPriceTabFcfResults
                fairPrice={fairPriceFCF}
                currentPrice={currentPrice}
                upsideDownside={upsideDownsideFCF}
                currency={currency}
            />
        </Form>
    );
});
